import { Omit, Switch, SwitchProps } from 'bold-ui'

import { UseFieldProps, usePecField } from '../hooks/useField'

export type SwitchFieldProps = UseFieldProps<boolean> & Omit<SwitchProps, 'name'>

export function SwitchField(props: SwitchFieldProps) {
  // TODO (@RNG): Ajustar tipagem para não precisar de cast #29625
  const castProps = ({ type: 'checkbox', ...props } as unknown) as UseFieldProps<string>
  const { input, meta, ...rest } = usePecField(castProps)

  return <Switch {...input} {...rest} />
}
